import { Anchor, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

import { useGetMe } from "../api/generated/endpoints/identity/identity";
import { accessScopeQuery } from "../api/session";

/**
 * For staff in no team: their teams, their own included, are set up in the Admin Panel, whose
 * Create team works with no team (A7). The self-serve way may be closed (D1:
 * `TEAM_CREATION_CLOSED`), and the SPA cannot know until it asks. So the no-team landing and
 * Create a team point to the panel, and neither is a dead end (spec
 * ui-perf/staff-no-team-admin-panel, issue 1620). It shows nothing to anyone else, nor to staff
 * in a team, whose sidebar has the Admin Panel.
 */
export function AdminPanelHint() {
  const staff = useGetMe({ query: { select: (me) => me.is_staff } }).data === true;
  const noTeam =
    useQuery({ ...accessScopeQuery(), select: (scope) => scope.teams.length === 0 }).data === true;
  if (!staff || !noTeam) return null;
  return (
    <Text c="var(--cai-color-text-muted)">
      Teams are set up in the{" "}
      <Anchor renderRoot={(props) => <Link {...props} to="/staff" />}>Admin Panel</Anchor>.
    </Text>
  );
}
